import {View} from 'MWC';
import tpl from '../templates/VerticalTabs.jsx';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
    }
}
